export enum EPropertyTypes {
    string, number, boolean, dropdown, dateTime, listOfOptions, url, input, dynamic, time, guid, json, decimal, wholeNumber, query, checkboxList, validationConfig, xml, entityFilterQuery
}
export enum EComponentTypes {
    block, action, decision, step, summary, sharedJourney, submission, redirect, loop
}
export enum EValueType {
    string, number, boolean, dateTime, decimal, json, guid, currency, double, optionSetValue, optionSetLabel, summary
}

export enum EActionTypes {
    mathAction
}
export enum EControlTypes {
    boolean, contentSnippet, dateTime, listOfOptions, numericValue, section, textbox
}
export enum EConditionTypes {
    default
}
export enum EOperatorType {
    MoreThan, MoreThanOrEquals, LessThan, LessThanOrEquals, Equals, DoesNotEquals, Contains, BeginsWith, EndsWith, ContainsData, DoesNotContainData
}
export enum EConfirmationOperationType {
    ToggleComponent, DeleteJESetting, CascadeOutputValues, DeleteDecision, SetSharedJourney, SetTriageJourney, SetPageJourney, SetHideSteps, setRepalceGuids, setSaveAndResume, uncheckTriageJourney, uncheckPageJourney, uncheckHideSteps, DeleteLoop, DeleteDecisionBranch, DeleteControl, DeleteLayoutPanel,
    ChangeEntity, DeleteSharedJounrey, DeleteAction, DeleteSubmission, DeleteFirstLoopComponent
}

export enum EModalType {
    None, ControlConfig, SaveAs, ActionConfig, DecisionConfig, GlobalOutputs, Summary, SubmissionConfig, SharedJourneyConfig, JourneyTypeConfig, RedirectConfig,
    ControlBlockLooping, AuthenticationWarning, Blank, LoopConfig, AddComponent

}

export enum EOutputLookupContext {
    NotSpecified, DecisionConfig, PropertyConfig, ControlConfig, ControlValidationConfig, VisibilityExpressionConfig
}

export enum ERedirectCandidateType {
    serviceType, //, journey, url
    external
}

export enum EPropertyAdjustmentConditionOperator {
    Equals, NotEquals, GreaterThan, IsEmpty, IsNotEmpty
}

export enum EValidationType {
    Error = 1, Warning = 2
}

export enum EJourneyToolSearchType {
    Default, Upgraded, NotUpgraded
}

export enum EValidationContext {
    Control, Loop
}

export enum EOutputScope {
    Local, Global, System, Loop, LoopLocal, LoopSystem
}

export enum SetOutputMethodType {
    UpdateFieldName, UpdateOptionLabel, UpdateOptionValue, UpdateOutputStaticName, UpdateOutputLogicalName, UpdateOutput, UpdateOutputName, UpdateItemTitle, UpdateItemUrl, UpdateItemIcon
}

export enum CRMFieldType {
    SingleLineOfText, MultipleLinesOfText, OptionSet, TwoOption, WholeNumber, FloatingPointNumber, DecimalNumber, Currency, DateAndTime, Lookup
}



// WEBPACK FOOTER //
// ./source/ts/helpers/enums.ts